import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable()
export class ChatService {

    chatRoomInfo: any = null; // {'data': {'room_id': '593f4576e8fbf', 'room_clear_dt': '0000-00-00 00: 00: 00',
    // 'unread_cnt': 0,'mb_id': 'wangta72', 'mb_nick': '인천옵빠', 'mb_level': 4,'room_type': 'P', 'room_expired': '2017-06-19 11: 02: 01',
    // 'msg': 'test', 'created': '2017-06-16T05: 04: 31.649Z'},'participants': [{'mb_nick': '인천옵빠', 'mb_id': 'wangta72'}]}
    constructor( private http: HttpService) { // private navCtrl: NavController,

    }

    setUnreadCntAll(callback: (body: any) => void) { // 서버에 접속하여 현재 읽지 않은 전체 찬스톡 갯수를 가져온다.
        // this.rest.getapi({url: 'chat/get_chancetalk_all_unread_cnt', params: {}}, function(obj){
        this.http.get({url: 'chat/get_chancetalk_all_unread_cnt'}).then((obj) => {
            const chatObj = {unreadCnt: 0, room_id: ''};
            if (obj.result) {
                chatObj.unreadCnt = obj.cnt;
            } else {

            }
            callback(chatObj);
        });

    } // init: function(){

    setChatRoom(obj: any) { // 서버에 접속하여 현재 읽지 않은 전체 찬스톡 갯수를 가져온다.
        this.chatRoomInfo = obj;
    } // setChatRoom: function(){

    getChatRoom() {
        return this.chatRoomInfo;
    }

    getCurrentChatRoomId() { // 서버에 접속하여 현재 읽지 않은 전체 찬스톡 갯수를 가져온다.
        if (!this.chatRoomInfo) {
            return '';
        } else {
            return this.chatRoomInfo.data.room_id;
        }
    } // getCurrentChatRoomId: function(){

}
